import Vue from 'vue';
import Vuex from 'vuex';
import i18n from '../i18n';

import firebase from '../firebase';
import { version } from '../../package.json';

Vue.use(Vuex);

let lang = localStorage.getItem('lang');
if (!lang) {
    lang = 'en';
}
i18n.locale = lang;

const store = new Vuex.Store({
    state: {
        version,
        locale: lang,
        role: null,
        currentUser: null,
        userProfile: {},
        currentKalameeting: null,
        kalameetingDetails: {}
    },
    mutations: {
        setLanguage(state, val) {
            state.locale = val;
            i18n.locale = val;
            localStorage.setItem('lang', val);
        },
        setUserRole(state, val) {
            state.role = val;
        },
        setCurrentUser(state, val) {
            state.currentUser = val;
            localStorage.setItem('currentUser', JSON.stringify(val));
        },
        setUserProfile(state, val) {
            state.userProfile = val;
            localStorage.setItem('userProfile', JSON.stringify(val));
        },
        setCurrentKalameeting(state, val) {
            state.currentKalameeting = val;
        },
        setKalameetingDetails(state, val) {
            state.kalameetingDetails = val;
        }
    },
    actions: {
        fetchUserProfile({ commit, state }) {
            firebase.usersCollection.doc(state.currentUser.uid)
                .get()
                .then((res) => {
                    commit('setUserProfile', res.data());
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        clearData({ commit }) {
            commit('setCurrentUser', null);
            commit('setUserProfile', null);
            commit('setUserRole', null);
            localStorage.removeItem('currentUser');
            localStorage.removeItem('userProfile');
            localStorage.removeItem('role');
        },
        resetKalameeting({ commit }) {
            commit('setCurrentKalameeting', null);
            commit('setKalameetingDetails', {});
        }
    },
    modules: {}
});

firebase.auth.onAuthStateChanged((user) => {
    const localUser = JSON.parse(localStorage.getItem('currentUser'));
    const localUserProfile = JSON.parse(localStorage.getItem('userProfile'));
    if (localUser) {
        store.commit('setCurrentUser', localUser);
    }
    if (localUserProfile) {
        store.commit('setUserProfile', localUserProfile);
    }
    if (user) {
        store.commit('setCurrentUser', user);
        store.dispatch('fetchUserProfile');
    }
});

export default store;
